import { render, staticRenderFns } from "./SizeFilter.vue?vue&type=template&id=95d3e11e&scoped=true"
import script from "./SizeFilter.vue?vue&type=script&lang=ts"
export * from "./SizeFilter.vue?vue&type=script&lang=ts"
import style0 from "./SizeFilter.vue?vue&type=style&index=0&id=95d3e11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d3e11e",
  null
  
)

export default component.exports